const parseResponse = async (response) => {
    const data = await response.json().catch(() => null);

    if (!response.ok) {
        return data ?? {
            status: 'error',
            error: response.statusText
        };
    }

    return data;
};

const simulatedsService = {
    async getAll(offset = 0, limit = 5) {
        const apiURL = process.env.REACT_APP_API + '/simulated/list';
        const token = localStorage.getItem('token') ?? null;

        let headers = {
            'Accept': 'application/json',
            'Content-type': 'application/json',
            'Authorization': `Bearer ${token}`
        }
        return await fetch(apiURL, {
            method: "POST",
            headers: headers,
            body: JSON.stringify({ offset, limit })
        })
        .then(parseResponse)
        .then((data) => {
            return data;
        })
        .catch((error) => {
            return error;
        });
    },
    async pending() {
        const apiURL = process.env.REACT_APP_API + '/simulated/pending';
        const token = localStorage.getItem('token') ?? null;

        let headers = {
            'Accept': 'application/json',
            'Content-type': 'application/json',
            'Authorization': `Bearer ${token}`
        }
        return await fetch(apiURL, {
            method: "POST",
            headers: headers,
            body: JSON.stringify({})
        })
        .then(parseResponse)
        .then((data) => {
            return data;
        })
        .catch((error) => {
            return error;
        });
    },
    async get(data) {
        const apiURL = process.env.REACT_APP_API + '/simulated/show';
        const token = localStorage.getItem('token') ?? null;

        let headers = {
            'Accept': 'application/json',
            'Content-type': 'application/json',
            'Authorization': `Bearer ${token}`
        }
        return await fetch(apiURL, {
            method: "POST",
            headers: headers,
            body: JSON.stringify(data)
        })
        .then(parseResponse)
        .then((data) => {
            return data;
        })
        .catch((error) => {
            return error;
        });
    },
    async new() {
        const apiURL = process.env.REACT_APP_API + '/simulated/start';
        const token = localStorage.getItem('token') ?? null;

        let headers = {
            'Accept': 'application/json',
            'Content-type': 'application/json',
            'Authorization': `Bearer ${token}`
        }
        return await fetch(apiURL, {
            method: "POST",
            headers: headers
        })
        .then(parseResponse)
        .then((data) => {
            return data;
        })
        .catch((error) => {
            return error;
        });
    },
    async finish(data) {
        const apiURL = process.env.REACT_APP_API + '/simulated/finish';
        const token = localStorage.getItem('token') ?? null;

        let headers = {
            'Accept': 'application/json',
            'Content-type': 'application/json',
            'Authorization': `Bearer ${token}`
        }
        return await fetch(apiURL, {
            method: "POST",
            headers: headers,
            body: JSON.stringify(data)
        })
        .then(parseResponse)
        .then((data) => {
            return data;
        })
        .catch((error) => {
            return error;
        });
    },
    async result(data) {
        const apiURL = process.env.REACT_APP_API + '/simulated/result';
        const token = localStorage.getItem('token') ?? null;

        let headers = {
            'Accept': 'application/json',
            'Content-type': 'application/json',
            'Authorization': `Bearer ${token}`
        }
        return await fetch(apiURL, {
            method: "POST",
            headers: headers,
            body: JSON.stringify(data)
        })
        .then(parseResponse)
        .then((data) => {
            return data;
        })
        .catch((error) => {
            return error;
        });
    },
    async incorrect(data) {
        const apiURL = process.env.REACT_APP_API + '/simulated/incorrect';
        const token = localStorage.getItem('token') ?? null;

        let headers = {
            'Accept': 'application/json',
            'Content-type': 'application/json',
            'Authorization': `Bearer ${token}`
        }
        return await fetch(apiURL, {
            method: "POST",
            headers: headers,
            body: JSON.stringify(data)
        })
        .then(parseResponse)
        .then((data) => {
            return data;
        })
        .catch((error) => {
            return error;
        });
    }
}

export default simulatedsService;
